import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { RequestMapper } from '../request-mapper';
import {
  parseEstablishmentId,
  parseStoredPermissionTree,
  PermissionView,
} from '../common-files/permission-tree';

// collect every webRoute the operator can open from the normalized permission tree
function collectRoutes(views: PermissionView[], routes: string[]): void {
  for (const view of views) {
    if (typeof view.webRoute === 'string' && view.webRoute) {
      routes.push(view.webRoute);
    }
    if (view.subview.length) {
      collectRoutes(view.subview, routes);
    }
  }
}

// allow a route only if the operator has a permitted view for it
export const permissionGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const path = route.routeConfig?.path;

  // super admin sees/does everything (mirrors the backend grants-all short-circuit);
  // super-admin screens are not seeded views, so they only pass via this bypass.
  // While viewing the app AS a role the bypass is off: routes come from that role.
  if (localStorage.getItem('isSuperAdmin') === 'true' && !localStorage.getItem('viewAs')) {
    return true;
  }

  const permittedRoutes: string[] = [];
  collectRoutes(
    parseStoredPermissionTree(
      localStorage.getItem('permissions'),
      parseEstablishmentId(localStorage.getItem('activeEstablishmentId')),
    ),
    permittedRoutes,
  );

  if (path && permittedRoutes.includes(path)) {
    return true;
  }

  // not allowed: send them to their first permitted screen, or back to login
  if (permittedRoutes.length) {
    router.navigate([RequestMapper.SIDENAV, permittedRoutes[0]]);
  } else {
    router.navigateByUrl(RequestMapper.LOGIN);
  }
  return false;
};
